import React, { useEffect } from 'react'
import Menu from './Menu'
import Sun from '../Images/sun.png'
import Moon from '../Images/moon.png'
import $ from "jquery"
import "./component.scss"
import { Link } from 'react-router-dom'
export default function Header() {
    const Section1= $('.flex-box-menu')
  useEffect(()=>{
  
    window.addEventListener('scroll', () => {
      if(window.scrollY>100){
      Section1.css("background","rgba(0,0,0,0.7)")
      Section1.css("box-shadow","0px 0px 30px 15px rgba(255, 183, 0, 0.109) ")
      }
      else{
        Section1.css("background","rgba(0, 0, 0, 0)")
        Section1.css("boxShadow","0px 0px 0px 0px")
      }
    })

  })
  const handleSun=()=>{$(".moon").show();$(".sun").hide();$(".flex-box-menu").css({'background':'rgb(163, 63, 4)'});$(".Footer").css({'background':'rgb(163, 63, 4)'})}
  const handleMoon=()=>{$(".sun").show();$(".moon").hide();$(".flex-box-menu").css({'background':'linear-gradient(0deg, rgb(32, 1, 60), rgb(32, 1, 60))'});$(".Footer").css({'background':'rgb(32, 1, 60)'})}
  return (<div>
      <div className='flex-box-menu' id='flex-box-menu'>
        <div className='logo'>
        <div onClick={handleSun}><img className="sun" src={Sun} alt=""/></div>
        <div onClick={handleMoon}><img className="moon" src={Moon} alt=""/></div>
        <div className='H-logo'>Abiboulaye</div>
         
        </div>
        
        <div className='H-menu'><Menu/></div>
        
        
        
    </div>
    <div className='menuflex1 '>
    <Link  to="/"><button onClick={()=>{$(".menuflex1").toggle()}} className="menubutton1">Home</button></Link>
    <Link style={{textDecoration: "none"}} to="/Projects"><button onClick={()=>{$(".menuflex1").toggle()}} className="menubutton1">Projects</button></Link>
    <Link  style={{textDecoration: "none"}} to="/Contactme"><button onClick={()=>{$(".menuflex1").toggle()}} className="menubutton1">Let's Connect</button></Link>
    </div>
    </div>
      
  )
}
